export default __webpack_public_path__ + "static/lozenge-icon-do-dark-6c594cec5535e822aa6f2ff9756539d7.png";